<template>
  <div>
    <el-radio-group v-model="path"  size="medium" @change="tabPath">
      <el-radio-button label="/recipeStatistics/consumables/cupsExpendChart">药杯总消耗趋势图</el-radio-button>
      <el-radio-button label="/recipeStatistics/consumables/cupsExpend">药杯总消耗量</el-radio-button>
      <el-radio-button label="/recipeStatistics/consumables/operator">代理商药杯消耗量</el-radio-button>
      <el-radio-button label="/recipeStatistics/consumables/pharmacy">药房药杯消耗量</el-radio-button>
      <el-radio-button label="/recipeStatistics/consumables/equipment">设备药杯消耗量</el-radio-button>
    </el-radio-group>
    <div style="margin-top: 20px">
      <keep-alive>
        <router-view v-if='$route.meta.keepAlive'></router-view>
      </keep-alive>
      <router-view v-if='!$route.meta.keepAlive'></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "anomaly",
  data() {
    return {
      path: "/recipeStatistics/consumables/cupsExpendChart"
    }
  },
  created() {
    this.path=this.$route.path
  },
  watch:{
      $route: {
        handler: function(val, oldVal){
          this.path=val.path
        },
        // 深度观察监听
        deep: true
      }
  },
  component: {
    //someComponent
  },
  methods: {
    //
    tabPath(){
      this.$router.push(this.path)
    }
  },
  mounted() {
    //
  }
}
</script>

<style lang="scss" scoped>
.index {

}
</style>